import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

import IModal from '@/js/components/molecules/IModal.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'WelcomeModal',
  props: {
    email: {}
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {


const emit = __emit;
const onClose = () => {
  emit('close');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IModal, { onClose: onClose }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.$style.content)
      }, [
        (_openBlock(), _createElementBlock("svg", {
          width: "90",
          height: "67",
          viewBox: "0 0 90 67",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          class: _normalizeClass(_ctx.$style.icon)
        }, _cache[0] || (_cache[0] = [
          _createElementVNode("path", {
            d: "M86.4844 0H3.51596C2.53194 0 1.63194 0.418667 1.01319 1.04754C0.394437 1.66192 0.000335335 2.54168 0.000335335 3.50542V63.4946C-0.0133756 64.4447 0.394437 65.3379 1.0269 65.9668C1.64565 66.5949 2.54582 67 3.51596 67H86.4844C87.441 67 88.341 66.5949 88.9734 65.9668C89.6066 65.3379 90 64.4447 90 63.4946V3.50542C90 2.54168 89.6066 1.66192 88.9734 1.04754C88.3549 0.418667 87.4545 0 86.4844 0ZM84.6984 9.39644V61.7344H5.28819V9.37182L40.4863 40.5185H40.5007C41.7661 41.6362 43.3832 42.2229 44.9866 42.2229C45.549 42.2229 46.0976 42.1247 46.6455 41.9854H46.8146L47.2368 41.8314C48.0519 41.5524 48.8115 41.1051 49.4863 40.5187C55.4562 35.2421 69.8667 22.4923 79.5586 13.919L84.6984 9.39644ZM81.3565 5.28624C72.711 12.9361 53.1787 30.2163 45.9705 36.5936C45.816 36.7196 45.647 36.8174 45.4788 36.8733C45.3236 36.9291 45.1554 36.9572 44.9865 36.9572C44.6349 36.9572 44.297 36.8453 44.0017 36.5799L8.60676 5.26564H50.3163L81.3565 5.28624Z",
            fill: "#C6937A"
          }, null, -1)
        ]), 2)),
        _cache[10] || (_cache[10] = _createTextVNode()),
        _createElementVNode("h3", {
          class: _normalizeClass(_ctx.$style.title)
        }, "メールアドレスを認証してください", 2),
        _cache[11] || (_cache[11] = _createTextVNode()),
        _createElementVNode("p", {
          class: _normalizeClass(_ctx.$style.lead)
        }, [
          _createTextVNode(_toDisplayString(_ctx.email) + "宛に認証用のメールをお送りしました。", 1),
          _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
          _cache[2] || (_cache[2] = _createTextVNode("\n        メールに記載されたボタンをクリックしてメールアドレスの認証を完了してください。\n      ", -1))
        ], 2),
        _cache[12] || (_cache[12] = _createTextVNode()),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.$style.text)
        }, [
          _createElementVNode("ul", null, [
            _cache[7] || (_cache[7] = _createElementVNode("li", null, "・メールはnoreply@iichi.comから送信しております。", -1)),
            _cache[8] || (_cache[8] = _createTextVNode()),
            _createElementVNode("li", null, [
              _cache[3] || (_cache[3] = _createTextVNode("・メールの有効期限は1時間です。1時間を経過した場合は", -1)),
              _createElementVNode("a", {
                href: "/your/account/email",
                class: _normalizeClass(_ctx.$style.link)
              }, "こちら", 2),
              _cache[4] || (_cache[4] = _createTextVNode("から再送してください。", -1))
            ]),
            _cache[9] || (_cache[9] = _createTextVNode()),
            _createElementVNode("li", null, [
              _cache[5] || (_cache[5] = _createTextVNode("・メールの認証でお困りの場合は", -1)),
              _createElementVNode("a", {
                href: "https://help.iichi.com/hc/ja/articles/360000025422",
                target: "_blank",
                class: _normalizeClass(_ctx.$style.link)
              }, "こちら", 2),
              _cache[6] || (_cache[6] = _createTextVNode("をご確認ください。", -1))
            ])
          ])
        ], 2)
      ], 2)
    ]),
    _: 1
  }))
}
}

})